/* eslint-disable arrow-body-style */
import { SelectInput } from '@abyss/web/ui/SelectInput';
import React from 'react';
import { constants } from '@src/routes/provider/common/constants';
import { SelectOption } from '@src/common/types';
import {
  linkAnalysisFilterPanelApi,
  useLinkAnalysisFilterPanelStore,
} from '../../mothership/linkAnalysisFilterPanel.state';
import { linkAnalysisId } from '../../types';
import { DEFAULT_HOP_VALUE } from './defaultHopValue';

export const HopsSelect = () => {
  const options: SelectOption[] = [DEFAULT_HOP_VALUE, 1, 2, 3, 4, 5].map(
    (hop) => ({
      label: `${hop}`,
      value: `${hop}`,
    })
  );
  const value = useLinkAnalysisFilterPanelStore((state) => state.hop);

  const loading = useLinkAnalysisFilterPanelStore((state) => state.loading);
  const placeholder = loading ? constants.LOADING : 'Select Hops';
  const renderValue = loading ? '' : value;
  const { setHopValue } = linkAnalysisFilterPanelApi;

  return (
    <div
      data-cy={`${linkAnalysisId}SelectHops`}
      data-value={value}
      data-options={JSON.stringify(options)}
      data-loading={loading}
    >
      <SelectInput
        label="Hops"
        placeholder={placeholder}
        value={renderValue}
        onChange={setHopValue}
        options={options}
        isLoading={loading}
      />
    </div>
  );
};
